import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { shareReplay, switchMap, tap } from 'rxjs/operators';

// services
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

// interfaces
import { ITerms } from 'src/app/core/interfaces/app/terms';
import { ICountry } from 'src/app/core/interfaces/location/country';
import { ICategory } from 'src/app/core/interfaces/category/category';
import { ISettingsResponse } from 'src/app/core/interfaces/app/settings';
import { IAboutUsResponse } from 'src/app/main.components/about/interfaces/about-us-response';

@Injectable({
  providedIn: 'root'
})
export class TopLevelSingleService {

  // Observables
  private _terms: Observable<ITerms> = this._api.Terms().pipe(shareReplay(1))
  private _setting: Observable<ISettingsResponse> = this._api.Setting().pipe(shareReplay(1))
  private _categories: Observable<ICategory[]> = this._api.mainCategories().pipe(shareReplay(1))
  private _countries: BehaviorSubject<ICountry[]> = new BehaviorSubject<ICountry[]>(null)
  private _about: BehaviorSubject<IAboutUsResponse> = new BehaviorSubject<IAboutUsResponse>(null)

  /**
   * Countries
   */
  public Countries$ = this._countries.pipe(
    switchMap(x => {

      // return data direct if it cached before
      if (x) return of(x);

      // get Countries
      return this._api.getCountries().pipe(
        tap(_ => this._countries.next(_)), // update BehaviorSubject
      )

    }),
    shareReplay(1), // share one subscriber with cached last state
  )
  
  /**
   * 
   */
  public About$ = this._about.pipe(
    switchMap(x => {

      // return data direct if it cached before
      if (x) return of(x);

      // get about app
      return this._api.AboutUs().pipe(
        tap(_ => this._about.next(_)), // update BehaviorSubject
      )

    }),
    shareReplay(1), // share one subscriber with cached last state
  )

  /**
   * 
   * @param _api 
   */
  constructor(private _api: ApiResponseService) {}

  /**
   * 
   */
  public get Categories$() {
    return this._categories
  }

  /**
   * 
   */
  public get Setting$() {
    return this._setting
  }  

  /**
   * 
   */
  public get Terms$() {
    return this._terms
  }

}
